// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AudioTwoToneSvg from "@fishx/icons-svg/es/asn/AudioTwoTone";
import FishxIcon from '../components/FishxIcon';

var AudioTwoTone = function AudioTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AudioTwoToneSvg
  }));
};

AudioTwoTone.displayName = 'AudioTwoTone';
export default React.forwardRef(AudioTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AudioTwoTone.js
// module id = 2038
// module chunks = 0